// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4919":"63b0be64ce011726","6736":"d4fe9cc2346ffd95"}[chunkId] + ".css";
};